import React from 'react';

import { LazyImg } from '../../hooks/useLazyLoad';

import classes from './AlternativeCertificates.scss';

export const AlternativeCertificates: React.FC = () => (
    <div className={classes.certificates}>
        <LazyImg
            className={classes.cyber}
            src="../../../static/img/cyber-essentials-transparent-hi-res.png"
            alt="Cyber Essentials certification"
        />
        <LazyImg
            className={classes.isoSmaller}
            src="../../../static/img/iso27001-hi-res.png"
            alt="ISO 27001 certification"
        />
        <LazyImg className={classes.iso} src="../../../static/img/iso45001-hi-res.png" alt="ISO 45001 certification" />
        <LazyImg className={classes.ecovadis} src="../../../static/img/ecovadis-hi-res.png" alt="EcoVadis medal" />
        <LazyImg className={classes.bsif} src="../../../static/img/bsif-hi-res.png" alt="BSIF member" />
        <LazyImg className={classes.bunzl} src="../../../static/img/bunzl-hi-res.png" alt="Bunzl" />
        <LazyImg className={classes.sedex} src="../../../static/img/sedex.png" alt="Sedex member" />
        <LazyImg
            className={classes.sedex}
            src="../../../static/img/disability-confident.png"
            alt="Disability Confident committed"
        />
        <div className={classes.paymentCards}>
            <LazyImg className={classes.iso} src="../../../static/img/paypal.png" alt="PayPal" />
            <LazyImg className={classes.iso} src="../../../static/img/visa.png" alt="Visa" />
            <LazyImg className={classes.iso} src="../../../static/img/mastercard.png" alt="Mastercard" />
            <LazyImg className={classes.iso} src="../../../static/img/amex.png" alt="American Express" />
        </div>
    </div>
);
